'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var expireAllCookies = function expireAllCookies() {
  return document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
  });
};

var localStorageSet = exports.localStorageSet = function localStorageSet(key, value) {
  return localStorage.setItem(key, JSON.stringify(value));
};

var localStorageClear = exports.localStorageClear = function localStorageClear(key) {
  expireAllCookies();
  localStorage.removeItem(key);
};

var localStorageGet = exports.localStorageGet = function localStorageGet(key) {
  var jsonString = localStorage.getItem(key);
  var parsedJson = null;

  if (jsonString) {
    try {
      parsedJson = JSON.parse(jsonString);
    } catch (e) {
      localStorageClear(key);
    }
  }
  return parsedJson;
};

var localStorageAppend = exports.localStorageAppend = function localStorageAppend(key, value) {
  var json = localStorageGet(key);
  if (json) {
    var newObject = _extends({}, json, value);
    localStorageSet(key, newObject);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/local-storage/index.js
// module id = 584
// module chunks = 0